<h3>{{ title }}</h3>
<br />
<div>
  <p [innerHTML]="message | safe : 'html'"></p>
</div>
<br />
<div>
  <button class="btn btn-inverse" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button class="btn btn-primary" (click)="onConfirmClick()">Confirm</button>
</div>
